export default "__VITE_ASSET__B5g24RnP__"